import { IUser } from '../interfaces'
import { post } from '../_api'

export const login = async (email: string, password: string) => {
  const responseData = await post('auth/signin', {
    email,
    password
  })

  if (responseData?.token && responseData?.name) {
    const user: IUser = {
      id: responseData.id,
      name: responseData.name,
      token: responseData.token,
      expiresIn: Date.now() + parseInt(responseData.expiresIn) * 1000,
      email
    }

    localStorage.setItem('_a_user', JSON.stringify(user))

    return user
  }
}

export const logout = () => {
  localStorage.removeItem('_a_user')
  window.location.href = '/login';
}


export const getUserFromLocalStorage = () => {
  const userJSON = localStorage.getItem('_a_user')
  if (userJSON) return JSON.parse(userJSON)

  return null
}